import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import AuthRoute from './HOC/AuthRoute'

import Layout from './Layout';
import Landing from './Landing';
import Reserve from './Reserve';
import About from './About';
import NotFound from './NotFound';
import Order from './Order';
import Station from './Station';
import Login from './Auth/Login';
import Logout from './Auth/Logout';
import UploadMenu from './Product/UploadMenu';
import Menu from './Menu';
import Loc2 from './Loc2';

// New design pages
import Landing2 from './Landing2';
import NewMenu from './NewMenu';
import NewAbout from './NewAbout';
import LunchSpecial from './LunchSpecial';
import TacoTuesday from './TacoTuesday';
import Reservation from './Reservation';
import ReservationDetails from './ReservationDetails';
import ReservationThankYou from './ReservationThankYou';

const Root = () => (
  <BrowserRouter>
    <Switch>
      {/* ── New design pages (self-contained, no Layout wrapper) ── */}
      <Route exact path="/landing2" component={Landing2} />
      <Route exact path="/menu" component={NewMenu} />
      <Route exact path="/new-about" component={NewAbout} />
      <Route exact path="/lunch-special" component={LunchSpecial} />
      <Route exact path="/taco-tuesday" component={TacoTuesday} />
      <Route exact path="/reservation" component={Reservation} />
      <Route exact path="/reservation/details" component={ReservationDetails} />
      <Route exact path="/reservation/thank-you" component={ReservationThankYou} />

      {/* ── Existing pages (unchanged, inside Layout) ───────────── */}
      <Route render={({ location }) => (
        <Layout>
          <Switch location={location}>
            <AuthRoute exact path="/stations" component={Station} />
            <AuthRoute exact path='/upload_menu' component={UploadMenu} />
            <Route exact path="/" component={Landing} />
            {/* <Route exact path="/reserve" component={Reserve} /> */}
            <Route exact path="/menu2" component={Loc2} />
            <Route exact path="/about" component={About} />
            {/* <Route exact path="/order" component={Order} /> */}
            {/* <Route exact path="/order/cart" render={() => <Order viewCart={true} />} /> */}
            <Route exact path='/login' component={Login} />
            <Route exact path='/logout' component={Logout} />
            <Route component={NotFound} />
          </Switch>
        </Layout>
      )} />
    </Switch>
  </BrowserRouter>
);

export default Root;
